var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAccInterview5 = function SvgIconAccInterview5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon_acc_interview5_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.875,
    width: 96,
    height: 96,
    rx: 18,
    fill: "url(#icon_acc_interview5_svg__b)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon_acc_interview5_svg__c)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 22.875,
    width: 34,
    height: 43,
    rx: 3.478,
    fill: "#59C4CB"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon_acc_interview5_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.392 43.821a8.946 8.946 0 0 1-8.946 8.947h-7.735c-.938 0-1.407-1.135-.744-1.798l1.523-1.523a8.946 8.946 0 1 1 15.903-5.626Z",
    fill: "#9EDDE1"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M30.498 44.874a1.052 1.052 0 1 0 0-2.105 1.052 1.052 0 0 0 0 2.105ZM34.444 44.874a1.052 1.052 0 1 0 0-2.105 1.052 1.052 0 0 0 0 2.105ZM38.392 44.874a1.052 1.052 0 1 0 0-2.105 1.052 1.052 0 0 0 0 2.105Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon_acc_interview5_svg__e)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 31.875,
    width: 34,
    height: 43,
    rx: 4.092,
    fill: "url(#icon_acc_interview5_svg__f)",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon_acc_interview5_svg__g)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.662,
    y: 49.158,
    width: 4.934,
    height: 11.201,
    rx: 1.067,
    fill: "#59C4CB"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon_acc_interview5_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.893 58.354v-7.36c0-.293.096-.578.274-.81l3.876-5.065a2.167 2.167 0 0 1 3.88 1.497l-.231 2.771a1.067 1.067 0 0 0 1.063 1.155h3.755a2.134 2.134 0 0 1 2.01 2.847l-2.68 7.556a1.6 1.6 0 0 1-1.508 1.065h-5.461a1.6 1.6 0 0 1-.874-.26l-3.499-2.279a1.333 1.333 0 0 1-.605-1.117Z",
    fill: "#fff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon_acc_interview5_svg__a",
    x: -1,
    y: -0.125,
    width: 98,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_17861_14119"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.284566 0 0 0 0 0.667191 0 0 0 0 0.656563 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_17861_14119",
    result: "effect2_innerShadow_17861_14119"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icon_acc_interview5_svg__c",
    x: 17.5,
    y: 22.875,
    width: 34,
    height: 43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.073
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.698039 0 0 0 0 0.686275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_17861_14119"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icon_acc_interview5_svg__d",
    x: 25.5,
    y: 34.875,
    width: 17.893,
    height: 17.892,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.123
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.698039 0 0 0 0 0.686275 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_17861_14119"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icon_acc_interview5_svg__e",
    x: 42.203,
    y: 27.578,
    width: 42.593,
    height: 51.593,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 2.148
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_17861_14119"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_17861_14119",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icon_acc_interview5_svg__g",
    x: 54.662,
    y: 49.158,
    width: 4.934,
    height: 11.201,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.862
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.698039 0 0 0 0 0.686275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_17861_14119"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icon_acc_interview5_svg__h",
    x: 57.621,
    y: 42.998,
    width: 17.295,
    height: 20.284,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 0.636
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_17861_14119"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_17861_14119",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon_acc_interview5_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 21.5 -17 0 63.5 53.375)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_acc_interview5_svg__b",
    x1: 48,
    y1: 0.875,
    x2: 48,
    y2: 96.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7F7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2EDEB"
  })))));
};
export default SvgIconAccInterview5;